export default {
  test: 'test-i18n',
}
